import types from '../constants/notifConstants';

export const successNotif = (msg) => ({
  type: types.SUCCESS_NOTIF,
  payload: msg,
});

export const failedNotif = (msg) => ({
  type: types.FAILED_NOTIF,
  payload: msg,
});

export const getNotifFromAction = (data) => ({
  type: types.GET_NOTIF_FROM,
  payload: data,
});

export const setNotifFromAction = (data) => ({
  type: types.SET_NOTIF_FROM,
  payload: data,
});

export const getNotifFromDetailAction = (data) => ({
  type: types.GET_NOTIF_FROM_DETAIL,
  payload: data,
});

export const setNotifFromDetailAction = (data) => ({
  type: types.SET_NOTIF_FROM_DETAIL,
  payload: data,
});

export const getNotifToAction = (data) => ({
  type: types.GET_NOTIF_TO,
  payload: data,
});

export const setNotifToAction = (data) => ({
  type: types.SET_NOTIF_TO,
  payload: data,
});

export const getNotifToDetailAction = (data) => ({
  type: types.GET_NOTIF_TO_DETAIL,
  payload: data,
});

export const setNotifToDetailAction = (data) => ({
  type: types.SET_NOTIF_TO_DETAIL,
  payload: data,
});

export const setNotifToDetailErrorAction = () => ({
  type: types.SET_NOTIF_TO_DETAIL_ERROR,
});

export const setNotifFromDetailErrorAction = () => ({
  type: types.SET_NOTIF_FROM_DETAIL_ERROR,
});

export const acceptRequestAction = (data) => ({
  type: types.ACCEPT_REQUEST,
  payload: data,
});

export const declineRequestAction = (data) => ({
  type: types.DECLINE_REQUEST,
  payload: data,
});

export const deleteRequestAction = (data) => ({
  type: types.DELETE_REQUEST,
  payload: data,
});

export const setNotificationActivityAction = () => ({
  type: types.SET_NOTIF_ACTIVITY,
});

export const setActivityTimeAction = (data) => ({
  type: types.SET_ACTIVITY_TIME,
  payload: data,
});
